/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'underscore',
        'assets/js/modules/widgets/mailingLists/view/tableView',
        'assets/js/modules/widgets/mailingLists/model/mailingListsWidgetModel',
        'assets/js/modules/widgets/mailingLists/mailingListItemCollection',
        'assets/js/modules/browser',
        'Handsontable'
    ],
    function($, _, TableView, MailingListsWidgetModel, MailingListItemCollection, browser, Handsontable) {
        var model;

        return TableView.extend({
            initialize: function(options) {
                var _this = this;
                //save model to closure so renderers can use it
                model = this.model;
                this.height = options.height || 487;

                this.listenTo(this.model, {
                    'change:listLoading': this.updateListLoading
                });

                TableView.prototype.initialize.apply(this, arguments);

                this._undoRedoHooks();

                this.onChangeHooks();
                this.onUndoRedoHooks();

                this.getTableElement().handsontable('addHook', 'afterCreateRow', function(index, amount) {
                    _this.trigger('table:rowCreated', index, amount);
                });

                var scrollHandler = _.debounce(function() {
                    var item = _this.getTableElement().handsontable('getSourceDataAtRow', this.rowOffset());
                    _this.trigger('table:scroll', item, _this.countVisibleRows());
                }, 300);
                this.getTableElement().handsontable('addHook', 'afterScrollVertically', scrollHandler);

                this.updateListLoading();
            },

            initHandsontable: function(data) {
                var _this = this;
                this.getTableElement().handsontable({
                    data: data,
                    dataSchema: function() {
                        return MailingListItemCollection.getDefaultItem({
                            orderId: _this.model
                                .get('currentList')
                                .get('itemsCollection')
                                .getNextOrderId(),
                            loaded: true
                        });
                    },
                    undo: true,
                    minRows: MailingListsWidgetModel.MIN_LIST_ITEMS_LENGTH,
                    height: _this.height,
                    rowHeaders: true,
                    viewportRowRenderingOffset: 70,
                    viewportColumnRenderingOffset: 70,
                    colWidths: [40, 100, 125, 90, 140, 140, 172, 155, 140, 90, 90],
                    colHeaders: function(col) {
                        switch (col) {
                            case 0:
                                return (
                                    '<input type="checkbox" class="select-all-items checkbox-simple" id="select-all-items-id"' +
                                    (_this.model.get('allItemsSelected') ? ' checked' : '') +
                                    '><label class="checkbox-simple" for="select-all-items-id">&nbsp;</label>'
                                );
                            case 1:
                                return MailingListItemCollection.titles.title;
                            case 2:
                                return MailingListItemCollection.titles.firstName;
                            case 3:
                                return MailingListItemCollection.titles.middleInitial;
                            case 4:
                                return MailingListItemCollection.titles.lastName;
                            case 5:
                                return MailingListItemCollection.titles.company;
                            case 6:
                                return MailingListItemCollection.titles.address;
                            case 7:
                                return MailingListItemCollection.titles.address2;
                            case 8:
                                return MailingListItemCollection.titles.city;
                            case 9:
                                return MailingListItemCollection.titles.state;
                            case 10:
                                return MailingListItemCollection.titles.postalCode;
                        }
                    },
                    columns: [
                        {
                            type: 'checkbox',
                            data: 'selected',
                            renderer: checkBoxRenderer,
                            disableVisualSelection: true
                        },
                        {
                            type: 'text',
                            data: 'title'
                        },
                        {
                            type: 'text',
                            data: 'firstName',
                            renderer: firstNameRenderer
                        },
                        {
                            type: 'text',
                            data: 'middleInitial'
                        },
                        {
                            type: 'text',
                            data: 'lastName',
                            renderer: lastNameRenderer
                        },
                        {
                            type: 'text',
                            data: 'company'
                        },
                        {
                            type: 'text',
                            data: 'address'
                        },
                        {
                            type: 'text',
                            data: 'address2'
                        },
                        {
                            type: 'text',
                            data: 'city'
                        },
                        {
                            type: 'text',
                            data: 'state'
                        },
                        {
                            type: 'text',
                            data: 'postalCode'
                        }
                    ]
                });

                if (browser.isMobile()) {
                    Handsontable.dom.addEvent(this.el, 'touchstart', labelStopPropagationEvent);
                    Handsontable.dom.addEvent(this.el, 'touchend', checkboxEventHandler);
                } else {
                    Handsontable.dom.addEvent(this.el, 'mousedown', labelStopPropagationEvent);
                    Handsontable.dom.addEvent(this.el, 'mouseup', checkboxEventHandler);
                }

                function labelStopPropagationEvent(e) {
                    if ($(e.target).is('label')) {
                        e.stopPropagation();
                    }
                }

                function checkboxEventHandler(e) {
                    var $checkbox = $(e.target).prev();
                    if ($checkbox.is('input')) {
                        var isSelected = !$checkbox.is(':checked');
                        if ($checkbox.is('.select-all-items')) {
                            _this.model.trigger('items:selectAll', isSelected);
                        }
                        if ($checkbox.parent().is('.row-selector')) {
                            var rowIndex =
                                $checkbox
                                    .closest('tr')
                                    .find('.rowHeader')
                                    .text() - 1;
                            var item = _this.getTableElement().handsontable('getSourceDataAtRow', rowIndex);
                            _this.model.trigger('item:select', item, isSelected);
                        }
                    }
                }
            },

            _undoRedoHooks: function() {
                var _this = this;

                // new action - Remove several rows at time
                Handsontable.plugins.UndoRedo.RemoveRowsAction = function(itemsCollection, indexes) {
                    this.itemsCollection = itemsCollection;
                    this.indexes = indexes;
                };
                Handsontable.plugins.UndoRedo.RemoveRowsAction.prototype.undo = function(instance, undoneCallback) {
                    _this.listenToOnce(_this.model, 'items:restored', function() {
                        undoneCallback();
                        _this.model.trigger('undoredo:refresh');
                    });
                    _this.model.trigger('items:restore', this.itemsCollection, this.indexes);
                };
                Handsontable.plugins.UndoRedo.RemoveRowsAction.prototype.redo = function(instance, redoneCallback) {
                    _this.listenToOnce(_this.model, 'items:removed', function() {
                        redoneCallback();
                        _this.model.trigger('undoredo:refresh');
                    });
                    _this.model.trigger('items:remove', this.itemsCollection, this.indexes);
                };
            },

            logRemoveRowsAction: function(itemsCollection, indexes) {
                var action = new Handsontable.plugins.UndoRedo.RemoveRowsAction(itemsCollection, indexes);
                this.getTableElement()
                    .handsontable('getInstance')
                    .undoRedo.done(action);
            },

            addRow: function() {
                var index = this.getTableElement().handsontable('countRows');
                this.getTableElement().handsontable('alter', 'insert_row', index);
                this.getTableElement().handsontable('selectCell', index, 1);
            },

            updateListLoading: function() {
                if (this.model.get('listLoading')) {
                    this.$loading.show();
                } else {
                    this.$loading.hide();
                }
            },

            scrollToFirstCell: function() {
                this.getTableElement().handsontable('selectCell', 0, 1);
            },

            onChangeHooks: function() {
                var _this = this;
                var itemsCollection = new MailingListItemCollection([]);
                var wereEmpty = [];

                this.getTableElement().handsontable('addHook', 'beforeChange', function(changes, source) {
                    if (_this._isCheckAllCell(changes)) {
                        /**
                         * Disregard a single change
                         * @see https://docs.handsontable.com/0.34.0/Hooks.html#event:beforeChange
                         */
                        changes[0] = null;

                        return;
                    }

                    var data = null;
                    _.each(changes, function(change) {
                        data = _this.getTableElement().handsontable('getSourceDataAtRow', change[0]);
                        wereEmpty[change[0]] = MailingListItemCollection.isEmptyItem(data);
                    });
                });
                this.getTableElement().handsontable('addHook', 'afterChange', function(changes, source) {
                    var item = null;

                    _.each(changes, function(change) {
                        item = _this.getTableElement().handsontable('getSourceDataAtRow', change[0]);
                        let items = itemsCollection.getItems();
                        items[change[0]] = item;
                    });

                    if (changes) {
                        _this.trigger('table:change', itemsCollection, wereEmpty);
                    }
                });
            },

            onUndoRedoHooks: function() {
                var _this = this;

                this.getTableElement().handsontable('addHook', 'undo', function() {
                    _this.trigger('table:undo');
                });
                this.getTableElement().handsontable('addHook', 'redo', function() {
                    _this.trigger('table:redo');
                });
            },

            /**
             * As hadsontable method `rowOffset` returns not the first visible row,
             * but usually 15-18 rows before,
             * we'll add 50 more rows for calculating and loading the last page
             *
             * @return {number}
             */
            countVisibleRows: function() {
                return this.getTableElement().handsontable('countVisibleRows') + 50;
            },

            /**
             * @param {Array} changes
             * @return {boolean}
             */
            _isCheckAllCell: function(changes) {
                // If row index is NaN - that's "check all" checkbox
                return isNaN(changes[0][0]);
            }
        });

        // to center checkboxes. "className" property doesn't work for 'checkbox' column type for some reason
        function checkBoxRenderer(instance, td, row, col, prop, value, cellProperties) {
            Handsontable.renderers.CheckboxRenderer.apply(this, arguments);
            var id = 'checkbox-' + row + '-' + col;
            var checkbox = td.childNodes[0];
            checkbox.id = id;
            checkbox.classList.add('checkbox-simple');
            checkbox.classList.remove('htCheckboxRendererInput');
            var label = document.createElement('label');
            label.classList.add('checkbox-simple');
            label.htmlFor = id;
            td.appendChild(label);
            $(td).addClass('htCenter row-selector');
        }

        function firstNameRenderer(instance, td, row, col, prop, value, cellProperties) {
            if (model.get('currentList').get('addCurrentResident')) {
                var item = instance.getSourceDataAtRow(row);
                if (!MailingListItemCollection.isEmptyItem(item)) {
                    if (!(item['firstName'] || item['middleInitial'] || item['lastName'])) {
                        value = 'Current';
                    }
                }
            }
            Handsontable.renderers.TextRenderer.apply(this, arguments);
        }

        function lastNameRenderer(instance, td, row, col, prop, value, cellProperties) {
            if (model.get('currentList').get('addCurrentResident')) {
                var item = instance.getSourceDataAtRow(row);
                if (!MailingListItemCollection.isEmptyItem(item)) {
                    if (!(item['firstName'] || item['middleInitial'] || item['lastName'])) {
                        value = 'Resident';
                    } else {
                        value = value ? value + ' or Current Resident' : 'or Current Resident';
                    }
                }
            }
            Handsontable.renderers.TextRenderer.apply(this, arguments);
        }
    }
);
